import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const Wrapper = ({
  onClickItem,
  data,
  suggestFormatted,
  addSuggestion,
  limit,
  emptyText,
  onListShow,
}) => {
  const dropdownShown = useMemo(
    () =>
      (data && !!data.length && !!data.slice(0, limit).length) || !!emptyText,
    [emptyText, data]
  );

  useEffect(() => {
    return () => {
      onListShow(false);
    };
  }, []);

  useEffect(() => {
    onListShow(dropdownShown);
  }, [dropdownShown]);

  return (
    <div className="AutoSuggest__Wrapper__List__root">
      {data && !!data.length ? (
        data.slice(0, limit).map((item, key) => (
          <button
            key={key.toString()}
            className="AutoSuggest__Wrapper__List__item"
            type="button"
            onClick={() => onClickItem(item)}
          >
            {suggestFormatted(item).formatted}
          </button>
        ))
      ) : (
        <>
          {emptyText && (
            <div className="AutoSuggest__Wrapper__List__item AutoSuggest__Wrapper__List__item--empty">
              {emptyText}
            </div>
          )}
        </>
      )}
      {addSuggestion()}
    </div>
  );
};

Wrapper.propTypes = {
  suggestFormatted: PropTypes.func,
  onClickItem: PropTypes.func,
  addSuggestion: PropTypes.func,
  onListShow: PropTypes.func,
  data: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])
  ),
  limit: PropTypes.number,
};

Wrapper.defaultProps = {
  onListShow: () => {},
  onClickItem: () => {},
  data: undefined,
  suggestFormatted: () => {},
  addSuggestion: () => {},
  limit: undefined,
};
export default Wrapper;
